import { Component, HostBinding, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'dcc-billboard',
  template: `
    <span class="value">{{ value }}</span>
    <span class="label">{{ label }}</span>
  `,
  styleUrls: ['billboard.component.scss'],
})
export class BillboardComponent {
  @Input() direction: 'column' | 'row' = 'column';
  @Input({ required: true }) label!: string;
  @Input({ required: true }) value!: string | number;

  @HostBinding('class') get directionClass() {
    return `billboard-${this.direction}`;
  }
}
